/** Collapse a value's line breaks to single spaces — for a field that is ONE
 *  line of the scene (a scene logline or plot, ADR 0008 / #1835), whatever
 *  the input that filled it. A value with no line break is returned as is. */
export function toOneLine(text: string): string {
    if (!/[\r\n]/.test(text)) return text;
    return text
        .split(/[\r\n]+/)
        .map(part => part.trim())
        .filter(Boolean)
        .join(' ');
}
